// Contact form fields name
export const FIELD_NAMES = {
    REQUEST_TYPE: 'request_type',
    REQUEST_DETAIL: 'request_detail',
    CUSTOMER_TYPE: 'customer_type',
    COMPANY_NAME: 'company_name',
    DEPARTMENT_NAME: 'department_name',
    NAME: 'name',
    NAME_KANA: 'name_kana',
    EMAIL: 'email',
    PHONE: 'phone',
    FAX: 'fax',
    POSTAL_CODE: 'postal_code',
    ADDRESS: 'address',
    BUILDING: 'building',
    URL_HOMEPAGE: 'url_homepage'
};

// Error field IDs (matching error display mapping)
export const ERROR_FIELD_IDS = {
    [FIELD_NAMES.REQUEST_TYPE]: 'requestTypeError',
    [FIELD_NAMES.REQUEST_DETAIL]: 'requestDetailError',
    [FIELD_NAMES.CUSTOMER_TYPE]: 'customerTypeError',
    [FIELD_NAMES.NAME]: 'nameError',
    [FIELD_NAMES.NAME_KANA]: 'nameKanaError',
    [FIELD_NAMES.EMAIL]: 'emailError',
    [`${FIELD_NAMES.PHONE}1`]: 'phoneError',
    [`${FIELD_NAMES.PHONE}2`]: 'phoneError',
    [`${FIELD_NAMES.PHONE}3`]: 'phoneError',
    [`${FIELD_NAMES.FAX}1`]: 'faxError',
    [`${FIELD_NAMES.FAX}2`]: 'faxError',
    [`${FIELD_NAMES.FAX}3`]: 'faxError',
    [`${FIELD_NAMES.POSTAL_CODE}1`]: 'postalCodeError',
    [`${FIELD_NAMES.POSTAL_CODE}2`]: 'postalCodeError',
    [FIELD_NAMES.URL_HOMEPAGE]: 'urlHomepageError'
};

// Field labels (Japanese)
export const FIELD_LABELS = {
    [FIELD_NAMES.REQUEST_TYPE]: 'お問い合わせ種別',
    [FIELD_NAMES.REQUEST_DETAIL]: 'お問い合わせ内容',
    [FIELD_NAMES.CUSTOMER_TYPE]: 'お客様区分',
    [FIELD_NAMES.COMPANY_NAME]: '会社名 / 団体名',
    [FIELD_NAMES.DEPARTMENT_NAME]: '部署名',
    [FIELD_NAMES.NAME]: 'お名前',
    [FIELD_NAMES.NAME_KANA]: 'ふりがな',
    [FIELD_NAMES.EMAIL]: 'メールアドレス',
    [FIELD_NAMES.PHONE]: '電話番号',
    [FIELD_NAMES.FAX]: 'FAX番号',
    [FIELD_NAMES.POSTAL_CODE]: '郵便番号',
    [FIELD_NAMES.ADDRESS]: '住所',
    [FIELD_NAMES.BUILDING]: 'マンション・ビル名',
    [FIELD_NAMES.URL_HOMEPAGE]: 'ホームページURL'
};
